module.exports = __webpack_public_path__ + "static/media/fz_slotedit_pt_PT.746cf096.png";